// extracted by mini-css-extract-plugin
module.exports = {"page-banner-image":"StandardPageHeader_page-banner-image__1MZ1B","header":"StandardPageHeader_header__3o0ub"};